module.exports = __webpack_public_path__ + "Mapa-Desktop.16c58a0731fcc8fad92e2032e2826c59.png";